module.exports = __webpack_public_path__ + "static/media/jio.490e8ec4.png";